import { v1, toResult } from '@/infrastructure/api/v1/client';
import { templateSubmissionToLegacy, type TemplateSubmissionDto } from '@/infrastructure/api/v1/mappers/templateSubmissions';
import { TemplateSubmission, SupabaseTemplateSubmission } from '@/types/templateSubmissionTypes';
import { convertToTemplateSubmission } from '@/utils/dataConverters';

// v1 does not carry the bigint row id, which nothing in the editor reads
export const toTemplateSubmission = (dto: TemplateSubmissionDto): TemplateSubmission =>
  convertToTemplateSubmission(templateSubmissionToLegacy(dto) as unknown as SupabaseTemplateSubmission);

/**
 * Fetch the template submission for a scene origin (if any).
 * There is at most one submission per scene_origin_id in the current design.
 */
export const fetchTemplateSubmissionBySceneOriginId = async (
  sceneOriginId: string
): Promise<TemplateSubmission | null> => {
  // listTemplateSubmissions is newest first
  const { data, error } = await toResult(v1.GET('/api/v1/template-submissions', {
    params: { query: { sceneOriginUniqueId: [sceneOriginId], limit: 1 } },
  }));

  // Null means no submission, so a failed read throws rather than reading as none
  if (error) throw error;
  const first = data.items[0];
  return first ? toTemplateSubmission(first) : null;
};

/** Service implementation for use in ServiceProvider. */
export class TemplateSubmissionsServiceImpl {
  async fetchBySceneOriginId(sceneOriginId: string): Promise<TemplateSubmission | null> {
    return fetchTemplateSubmissionBySceneOriginId(sceneOriginId);
  }
}
